// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3RG4X","itemTitle":"ClientEmergencyInfo_itemTitle__3_llJ","itemText":"ClientEmergencyInfo_itemText__2nE2_"};